import { List } from '@mui/material'
import { Fragment } from 'react'
import { getTopBarNavigationLinks } from '../../constants'
import { TopBarTopLinkProps } from '../../types'
import { ListItemLink } from '../links'
import { MobileSubMenuItemProps } from './mobile-sub-menu-item'
import { MobileSubMenu } from './mobile-sub-menu'

export interface MobileLinksProps
  extends Pick<MobileSubMenuItemProps, 'handleMobileMenuClose'> {
  useAdminTool: boolean
}

export const MobileLinks = ({
  handleMobileMenuClose,
  useAdminTool
}: MobileLinksProps) => {
  return (
    <List>
      {getTopBarNavigationLinks(useAdminTool).map(
        (link: TopBarTopLinkProps, index: number) => (
          <Fragment key={link.key}>
            {link.subMenu ? (
              <MobileSubMenu
                handleMobileMenuClose={handleMobileMenuClose}
                index={index}
                link={{
                  key: link.key,
                  subMenu: link.subMenu,
                  translationId: link.translationId
                }}
              />
            ) : (
              <ListItemLink link={link} onClick={handleMobileMenuClose} />
            )}
          </Fragment>
        )
      )}
    </List>
  )
}
